var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaceHappy = function SvgFaceHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0ZM12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5Zm-1.036 6.8c.563.88.285 2.324-1.613 3.83a.256.256 0 0 1-.24.042c-2.299-.766-3.053-2.027-2.826-3.048.11-.495.454-.897.91-1.082a1.561 1.561 0 0 1 1.326.081 1.561 1.561 0 0 1 1.218-.53c.492.019.952.278 1.225.706Zm3.925 3.872c2.299-.766 3.053-2.027 2.826-3.048a1.524 1.524 0 0 0-.91-1.082 1.561 1.561 0 0 0-1.326.081 1.562 1.562 0 0 0-1.217-.53 1.524 1.524 0 0 0-1.226.706c-.563.881-.285 2.325 1.613 3.83.068.055.158.07.24.043ZM12 18a4 4 0 0 0 3.962-3.447c.04-.294-.219-.526-.514-.5-2.309.206-4.587.206-6.896 0-.296-.026-.555.206-.514.5A4 4 0 0 0 11.999 18Z",
    clipRule: "evenodd"
  })));
};
export default SvgFaceHappy;